import React from "react";
import AppConstants from "../../constants/AppConstants";

const { LOCK_ICON_CIRCLE_SIZE: circleWidth, LOCK_ICON_OFFSETS: offsets } = AppConstants;

const LockedElements = ({ targets, onUnlockElement }) => (
  <>
    {Object.entries(targets).map((target) => {
      const [key, { a, h, w, x, y, type }] = target;
      return (
        <g key={key}>
          <rect
            className="transformer-outline locked"
            style={{
              transform: `translate(${x}px, ${y}px) rotate(${a}deg)`,
              height: `${h}px`,
              width: `${w}px`,
            }}
          />
          <circle
            title="Unlock this element"
            style={{
              transformOrigin: `${w / 2 + circleWidth}px ${h / 2 + circleWidth}px`,
              transform: `rotate(${a}deg)`,
              cx: x,
              cy: type === "line" ? y + h / 2 : y,
              r: circleWidth,
            }}
            className="lock-circle"
            onClick={() => onUnlockElement(key)}
          />
          <text
            title="Unlock this element"
            className="toggle-lock-icon"
            style={{
              transform: `translate(${x + offsets.x}px, ${
                type === "line" ? y + h / 2 + offsets.y : y + offsets.y
              }px) rotate(${a}deg)`,
              transformOrigin: `${w / 2 + circleWidth + offsets.w}px ${
                h / 2 + circleWidth + offsets.h
              }px`,
            }}
          >
            {"\uE204"}
          </text>
        </g>
      );
    })}
  </>
);

export default LockedElements;
